import { CTACLASSNAME } from "./constants"

const logColors = {
  FgBlack: "\x1b[30m",
  FgRed: "\x1b[31m",
  FgGreen: "\x1b[32m",
  FgYellow: "\x1b[33m",
  FgBlue: "\x1b[34m",
  FgMagenta: "\x1b[35m",
  FgCyan: "\x1b[36m",
  FgWhite: "\x1b[37m",
}

const logColorsByHook = {
  Main: "red",
  Callback: "magenta",
  onChange: "grey",
  useEffect: "green",
  useLayoutEffect: "green",
  CustomHook: "blue",
  Listener: "gold",
  Func: "pink",
}

const filterChar = "WatchVariations"

export const logmine = (color, ...args) => {
  //  return null
  const colortype = logColorsByHook[color]
  const colorcode = colortype || color
  const display = []
  const hide = []
  //  console.log.apply(null, [colorcode, [filterChar, ...args]])
  let ready = display.reduce((a, item) => {
    return a || !!~args.indexOf(item) || color === item
  }, !display.length)
  ready = hide.reduce((a, item) => {
    return a && color !== item
  }, ready)
  if (ready) {
    console.log.apply(null, [["%c", filterChar, ...args].join(" "), `background: ${colorcode}; color: white;`])
    const last = args.pop()
    if (typeof last === "object") console.log(last)
  }
}

export const cssApply = (el, props, straight) => {
  if (!el || !props) return
  props.map(line => {
    const prop = line[0]
    el.style[prop] = straight && prop === "transition" ? "none" : line[1]
  })
}

export const upperFirstLetter = s => {
  return !!s && [s.charAt(0).toUpperCase(), s.slice(1)].join("")
}

export const stampCta = ref => {
  const { current: root } = ref
  if (!root) return
  const el = root.querySelector("button,a")
  if (!el) return
  el.classList.add(CTACLASSNAME)
}

export const focusCta = ref => {
  const { current: root } = ref
  if (!root) return
  const el = root.querySelector(`.${CTACLASSNAME}`)
  if (!el) return
  el.focus()
}

export function rafDelay(fn = null) {
  if (!process.browser || !fn) return
  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(function () {
      fn()
    })
  })
}

export function cssSwap(el, cn = "wv_reveal", fn = null) {
  if (!process.browser) return
  if (cn) el.classList.remove(cn)
  rafDelay(() => {
    if (typeof fn === "function") fn()
    if (!cn) return
    rafDelay(() => {
      el.classList.add(cn)
    })
  })
}
